import React, { FC } from 'react'

import AccessPermissions from './AccessPermissions'
import { OtherTabProps } from '../../AccountDetails.types'

const SomeOther: FC<OtherTabProps> = ({ ID, hash, data }) => {
  const { permslist } = data

  return (
    <div className="u-padding-10 u-fluid u-flex u-directionColumn">
      <div className="u-flex u-fluid u-flexBasis0">
        <AccessPermissions ID={ID} hash={hash} data={permslist} />
      </div>
    </div>
  )
}

export default SomeOther
